var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-simple-table',{attrs:{"fixed-header":"","height":"auto"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)}),_c('SmallText',[_vm._v(_vm._s(_vm.legenda))]),_c('SmallText',[_vm._v(_vm._s(_vm.fonte))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }